
import { Injectable } from '@angular/core';
import { SecureStoragePlugin } from '@atroo/capacitor-secure-storage-plugin';
import { logger } from 'src/app/common/services/logging/logging.service';
import { AsyncSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SecureStorageService {

  constructor() { }

  public set(key: string, value: string): AsyncSubject<boolean> {

    let subject = new AsyncSubject<boolean>();

    // whenUnlockedThisDeviceOnly keeps iOS Keychain items off device backups/migrations.
    // Android's native set() resolves with {} (no value:true); treat a resolved call as success.
    SecureStoragePlugin.set({ key, value, accessibility: 'whenUnlockedThisDeviceOnly' }).then((success) => {
      logger.debug(`Store : ${key} : ${value}`);
      subject.next(success?.value !== false);
      subject.complete();
    }).catch((err: unknown) => {
      logger.error(err);
      subject.next(false);
      subject.complete();
    });

    return subject;
  }

  public get(key: string): AsyncSubject<string> {
    let subject = new AsyncSubject<string>();

    // Missing keys throw; treat that (and a null/undefined value) as an empty string.
    SecureStoragePlugin.get({ key }).then((success) => {
      const storedValue = success.value ?? "";
      logger.debug(`Retrieve : ${key} : ${storedValue}`);
      subject.next(storedValue);
      subject.complete();
    }).catch((_err: unknown) => {
      subject.next("");
      subject.complete();
    });
    return subject;
  }

  public isExist(key: string): AsyncSubject<boolean> {
    let subject = new AsyncSubject<boolean>();

    SecureStoragePlugin.get({ key }).then((success) => {
      subject.next(success.value != null);
      subject.complete();
    }).catch((_err: unknown) => {
      subject.next(false);
      subject.complete();
    });
    return subject;
  }

  public remove(key: string) {
    SecureStoragePlugin.remove({ key }).then((success) => logger.debug(success)).catch((err: unknown) => logger.error(err));
  }

  public clearAll() {
    SecureStoragePlugin.clear().then((success) => logger.debug(success)).catch((err: unknown) => logger.error(err));
  }

}

export const enum SecureStorageType {
  CREDENTIAL = "CREDENTIAL",
  APP_AUTHENTICATOR_PRIVATE_KEY = "APP_AUTHENTICATOR",
  DEVICE_ID = "DEVICE_ID",
  /** Set after a biometric secret is bound to the current enrollment. */
  BIOMETRIC_ENROLLMENT = "BIOMETRIC_ENROLLMENT",
}
